// extracted by mini-css-extract-plugin
module.exports = {"section":"page_section__1jajO","header":"page_header__-n2np","actionIconButton":"page_actionIconButton__2kLLb","actionButton":"page_actionButton__2MvBc"};